export const premiumFeatureInfo = {
    application: {
        title: 'Apply for a Job with Pharmuni Premium',
        description: 'Streamline your applications by applying directly through our app. Pharmuni Premium offers an advanced application management system, including real-time chat with recruiters, status updates, and more.'
    },
    resume: {
        title: 'Create Your Resume with Pharmuni Premium',
        description: 'Stand out to potential employers by crafting a professional resume using our Premium Resume Builder. Highlight your skills and experience to make a lasting impression.'
    },
    coverletter: {
        title: 'Create Your Cover Letter with Pharmuni Premium',
        description: 'Stand out to employers by crafting personalized cover letters using our Premium Cover Letter Builder. Easily tailor your applications and make a lasting impression.'
    },
    skill: {
        title: 'Build Your Skill Tree with Pharmuni Premium',
        description: 'Develop a personalized Skill Tree to map out your competencies and learning goals. Showcase your expertise to employers and track your progress as you acquire new skills.'
    }
}